import { render, staticRenderFns } from "./commonSearch.vue?vue&type=template&id=a534a2bc&scoped=true&"
import script from "./commonSearch.vue?vue&type=script&lang=js&"
export * from "./commonSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a534a2bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a534a2bc')) {
      api.createRecord('a534a2bc', component.options)
    } else {
      api.reload('a534a2bc', component.options)
    }
    module.hot.accept("./commonSearch.vue?vue&type=template&id=a534a2bc&scoped=true&", function () {
      api.rerender('a534a2bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/commonSearch.vue"
export default component.exports